import { Store } from 'utils';

class ActiveResume extends Store {

	getInitialState() {
		return {
			resume: null,
			loading: false
		}
	}
	
	onLoadingResume(state) {
		state.loading = true;
		state.forbidden = false;
	}

	onResumeChanged(state, data) {
		state.loading = false;
		state.resume = data.resume;
		state.forbidden = data.forbidden === true;
	}
    onAdminResumeChanged(state, data) {
        this.onResumeChanged(state, data);
    }
    onHideResumeDetails(state){
        state.resume = null;
    }

}

const store = new ActiveResume();
export default store;


// WEBPACK FOOTER //
// ./src/modules/model/ActiveResume.js